/* External */
import {
  createContext,
  memo,
  useContext,
  useState,
} from 'react';
import PropTypes from 'prop-types';

/* Utils */
import useQuery from '../../hooks/useQuery';

const QueryParamsContext = createContext({});

export function useQueryParams() {
  return useContext(QueryParamsContext);
}

export function useQueriedDrm() {
  const queryParams = useQueryParams();
  return queryParams?.drm?.toUpperCase();
}

export function useQueriedPlayer() {
  const queryParams = useQueryParams();
  return queryParams?.player?.toUpperCase();
}

function QueryParamsProvider({ children }) {
  const { player, drm } = useQuery();
  const [queryParams] = useState(() => ({ player, drm }));

  return (
    <QueryParamsContext.Provider value={queryParams}>
      {children}
    </QueryParamsContext.Provider>
  );
}

QueryParamsProvider.propTypes = {
  children: PropTypes.node,
};

export default memo(QueryParamsProvider);
